import React, { useEffect, useRef, useState } from 'react';

interface ScrollHeaderProps {
  title: string;
}

const ScrollHeader: React.FC<ScrollHeaderProps> = ({ title }) => {
  const [isVisible, setIsVisible] = useState(true);
  const headerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        threshold: 0,
        rootMargin: '-96px 0px 0px 0px' // Adjusted for banner (32px) + header height (64px)
      }
    );

    if (headerRef.current) {
      observer.observe(headerRef.current);
    }

    return () => {
      if (headerRef.current) {
        observer.unobserve(headerRef.current);
      }
    };
  }, []);

  return (
    <>
      <div ref={headerRef}>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
          {title}
        </h1>
      </div>

      {/* Mobile sticky header */}
      <div 
        className={`fixed left-0 right-0 md:hidden bg-light-surface dark:bg-dark-surface border-b border-light-border dark:border-dark-border transition-all duration-200 ${
          !isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4 pointer-events-none'
        }`} 
        style={{ top: '80px', zIndex: 19 }}
      >
        <div className="px-6">
          <div className="flex items-center justify-center py-3">
            <h2 className="text-xl font-bold text-gray-900 dark:text-white">
              {title}
            </h2>
          </div>
        </div>
      </div>

      {/* Desktop floating header in navbar */}
      <div 
        className={`fixed left-0 right-0 h-16 hidden md:block pointer-events-none transition-all duration-200 ${
          !isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'
        }`}
        style={{ top: '32px', zIndex: 21 }}
      >
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-xl font-bold text-gray-900 dark:text-white">
            {title}
          </div>
        </div>
      </div>
    </>
  );
};

export default ScrollHeader;